import { useAppSelector } from "../hooks/app";
import { getSidebarStatus } from "../store/slices/layout-slice";
import AuthProvider from "./AuthProvider";

function LayoutProvider({
  children,
  classNames,
}: {
  children: React.ReactNode;
  classNames?: string;
}) {
  const sidebarStatus = useAppSelector(getSidebarStatus);
  return (
    <AuthProvider>
      <div className={`dashboard page ${sidebarStatus ? "avtive" : ""}`}>
        {children}
      </div>
    </AuthProvider>
  );
}

export default LayoutProvider;
